export interface TOCItem {
  id: string;
  text: string;
  level: number;
  children?: TOCItem[];
}

export function slugify(text: string): string {
  return text
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '')
    .replace(/[\s_-]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

export function generateTOC(content: string): TOCItem[] {
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = content;

  const allHeadings = tempDiv.querySelectorAll('h2, h3');
  const h2Headings: TOCItem[] = [];
  const usedIds = new Set<string>();

  let currentH2: TOCItem | null = null;

  allHeadings.forEach((heading) => {
    const text = heading.textContent || '';
    const level = parseInt(heading.tagName.substring(1));

    let id = heading.id;
    if (!id) {
      id = slugify(text);
      let counter = 2;
      while (usedIds.has(id)) {
        id = `${slugify(text)}-${counter}`;
        counter++;
      }
      heading.id = id;
    }

    usedIds.add(id);

    if (level === 2) {
      currentH2 = { id, text, level, children: [] };
      h2Headings.push(currentH2);
    } else if (level === 3 && currentH2) {
      currentH2.children!.push({ id, text, level });
    }
  });

  if (h2Headings.length < 3) {
    return [];
  }

  const maxItems = 12;
  return h2Headings.slice(0, maxItems);
}

export function addHeadingIds(content: string): string {
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = content;

  const headings = tempDiv.querySelectorAll('h2, h3');
  const usedIds = new Set<string>();

  headings.forEach((heading) => {
    if (!heading.id) {
      const text = heading.textContent || '';
      let id = slugify(text);
      let counter = 2;
      while (usedIds.has(id)) {
        id = `${slugify(text)}-${counter}`;
        counter++;
      }
      heading.id = id;
      usedIds.add(id);
    } else {
      usedIds.add(heading.id);
    }
  });

  return tempDiv.innerHTML;
}

export function cleanEmptyParagraphs(content: string): string {
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = content;

  const paragraphs = tempDiv.querySelectorAll('p');
  paragraphs.forEach((p) => {
    const text = p.textContent?.trim() || '';
    const hasOnlyBr = p.innerHTML.trim() === '<br>' || p.innerHTML.trim() === '<br/>';
    const hasImg = p.querySelector('img') !== null;

    // Don't remove paragraphs that contain images
    if (!hasImg && (text === '' || hasOnlyBr)) {
      p.remove();
    }
  });

  return tempDiv.innerHTML;
}
